import { useMyInfo } from 'src/services/apollo/auth'
import type { GenerationModelDetailFragment } from 'src/services/apollo/generated/graphql'
import { cx } from 'src/utils/cx'
import { getTrainingTasksFromModel } from '../GenerationModelTrainingTask/trainingTask'
import { TrainingTaskStatusChip } from '../GenerationModelTrainingTask/TrainingTaskStatusChip'
import { TrainingTaskStatus } from '../ModelTypeChip'

export function ModelTrainingTasksList(
  props: StyleProps & {
    model: Pick<
      GenerationModelDetailFragment,
      'authorId' | 'loraTrainingTasks' | 'trainingTask' | 'type'
    >
    /** Do not display completed tasks by default */
    showCompletedTasks?: boolean
  },
) {
  const { model, showCompletedTasks } = props
  const { data: userInfo } = useMyInfo()

  const isAuthor = model.authorId === userInfo?.id
  const loraTrainingTasks = getTrainingTasksFromModel(model)

  const trainingTasksToDisplay = loraTrainingTasks.filter(task => {
    if (!showCompletedTasks) return task.status !== TrainingTaskStatus.completed
    /** Nothing filtered */
    return true
  })

  if (trainingTasksToDisplay.length < 1 || !isAuthor) return null

  return (
    <div
      className={cx(
        'flex gap-2 py-1 -my-1 overflow-x-auto',
        // Paddings for preventing `overflow-auto` from clipping the item outlines.
        'px-[3px] -mx-[3px]',
        props.className,
      )}
      style={props.style}
    >
      {trainingTasksToDisplay.map(v => (
        <div
          key={v.id}
          className="flex-none flex items-center gap-1 leading-5 border p-1 rounded-md text-sm"
        >
          <span>{v.parameters.title}</span>
          <TrainingTaskStatusChip
            trainingTask={v}
            modelType={v.baseModel?.modelType}
            className="px-1.5 py-0.5 text-xs"
          />
        </div>
      ))}
    </div>
  )
}
